<template>
<div>
  <Head :leftarrow="true" :lroute="backs"></Head>
  <div class="me-center-nofoot">
    <div class="l-center">
      <div style="background-color: #fff;padding: 20px;">
        <p style="margin: 0px 0px 10px 0px;font-size: 16px;">{{info.title}}</p>
        <p style="margin: 0px;font-size: 12px;color: gray;">地址：{{info.address}}</p>
      </div>
      <van-cell-group>
        <van-cell title="联系电话：" :value="info.mobile" />
        <van-cell title="价格：" :value="info.price+'元起'" />
        <van-cell title="服务：" :value="info.tag" />
      </van-cell-group>
    </div>
  </div>
</div>
</template>

<script>
  import Head from '@/components/Head.vue'
  export default {
	metaInfo: {
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0, viewport-fit=cover' }
      ]
    },
    data(){
      return{
        api:'',
        apivalue:'',
        info:[]
      }
    },
    components: {
      Head
    },
    beforeCreate(){
      document.querySelector('body').setAttribute('style', 'background-color:#fff')
    },
    created(){
      this.movielist()
    },
    methods:{
      movielist(){
        this.api=this.$route.params.api
        this.apivalue=this.$route.params.apivalue
        this.$http.post(this.$burl+'&c=movient&m=getplace',{api:this.api,apivalue:this.apivalue})
        .then(res=>{
          this.info=res.data
        }).catch(()=>{})
      },
      backs(){
        this.$router.go(-1)
        return true;
      }
    }
  }
</script>

<style >
  .z-ym{
    background-color: #DCDCDC;
    height: 27px;
    margin: 0 auto;
    text-align: center;
    width: 180px;
    color: #676767;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    line-height: 27px;
    margin-bottom: 15px;
  }
  .z-left{
    width: 5%;
    float: left;
    background-color: #A8A8A8;
    border-radius: 10px;
    color: white;
  }
  .z-kuai{
    width: 75%;
    margin: 5px auto;
    margin-bottom:5px;
    height: 26px;
    border-radius: 3px;
    border: 1px solid #A8A8A8;
    background-color: white;
  }
  .z-left-kuai{
    float:left;
    width: 100%;
  }
  .z-left-kuai-span{
    text-align: center;
    margin: 5px auto;
    display: block;
    height: 28px;
    font-size: 13px;
    line-height: 28px;
  }
  .zc-1{
    height: 18px;
    width: 18px;
    display: inline-block;
    border-radius: 1px solid;
    border: 1px solid #A8A8A8;
    border-radius: 3px;
    vertical-align: bottom;
    margin-right: 5px;
    background-color: white;
  }
  .zc-2{
    height: 18px;
    width: 18px;
    display: inline-block;
    border-radius: 1px solid;
    border: 1px solid #FF4444;
    border-radius: 3px;
    vertical-align: bottom;
    margin-right: 5px;
    background-color: #FF4444;
  }
  .zc-3{
    height: 18px;
    width: 18px;
    display: inline-block;
    border-radius: 1px solid;
    border: 1px solid #62B900;
    border-radius: 3px;
    vertical-align: bottom;
    margin-right: 5px;
    background-color: #62B900;
  }
</style>